export default "__VITE_ASSET__bd514612__"